import '../../SearchDropdown.css';var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "react/jsx-runtime";
import { DirectionalHint } from "@fluentui/react/lib/Callout";
import { css } from "@fluentui/react/lib/Utilities";
import "../ComboBox/index.js";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import { getValues } from "../ReadOnly/readOnly.utils.js";
import { ComboBox } from "../ComboBox/ComboBox.js";
const SearchDropdown$1 = "";
const defaultClassName = "ane-AdvancedSearch-SearchDropdown";
const SearchDropdown = (_a) => {
  var _b = _a, {
    className,
    isReadOnly,
    id,
    label,
    selectedKey = "",
    ariaLabel,
    options
  } = _b, props = __objRest(_b, [
    "className",
    "isReadOnly",
    "id",
    "label",
    "selectedKey",
    "ariaLabel",
    "options"
  ]);
  const values = getValues(selectedKey, options, "text");
  return isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value: values }) : /* @__PURE__ */ jsx(
    ComboBox,
    __spreadValues({
      id,
      label,
      selectedKey,
      ariaLabel: ariaLabel || "",
      virtualized: true,
      className: css(defaultClassName, className),
      calloutProps: __spreadValues({
        directionalHintFixed: true,
        directionalHint: DirectionalHint.bottomLeftEdge,
        doNotLayer: true
      }, props.calloutProps),
      options,
      openOnKeyboardFocus: true,
      useComboBoxAsMenuWidth: true,
      scrollSelectedToTop: true,
      allowFreeform: true
    }, props)
  );
};
export {
  SearchDropdown,
  SearchDropdown as default
};
//# sourceMappingURL=SearchDropdown.js.map
